/* global axios */
import ApiClient from '../ApiClient';

class CaptainAutonomyConfig extends ApiClient {
  constructor() {
    super('captain_autonomy_configs', { accountScoped: true });
  }

  show(assistantId) {
    return axios.get(`${this.url}/${assistantId}`);
  }

  update(assistantId, data = {}) {
    return axios.patch(`${this.url}/${assistantId}`, {
      autonomy_config: data,
    });
  }

  updateToolRule(assistantId, toolId, ruleData = {}) {
    return axios.patch(`${this.url}/${assistantId}/update_tool_rule`, {
      tool_id: toolId,
      ...ruleData,
    });
  }

  testDataConnector(assistantId, connectorData = {}) {
    return axios.post(`${this.url}/test_data_connector`, {
      assistant_id: assistantId,
      ...connectorData,
    });
  }
}

export default new CaptainAutonomyConfig();
